export default __webpack_public_path__ + "static/media/7_2.0bdafc12.jpg";